var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserHubIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.9322 26.3314C32.9473 26.2577 33.0527 26.2577 33.0678 26.3314C33.85 30.1588 36.8411 33.1499 40.6685 33.9322C40.7422 33.9473 40.7422 34.0526 40.6685 34.0677C36.8411 34.85 33.85 37.8411 33.0678 41.6684C33.0527 41.7422 32.9473 41.7422 32.9322 41.6684C32.15 37.8411 29.1589 34.85 25.3315 34.0677C25.2577 34.0526 25.2577 33.9473 25.3315 33.9322C29.1589 33.1499 32.15 30.1588 32.9322 26.3314Z",
    stroke: "#B3FF10",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4375 21.7521C41.5626 21.1399 42.4374 21.1399 42.5625 21.7521C42.8389 23.1043 43.8956 24.1611 45.2478 24.4374C45.8601 24.5626 45.8601 25.4374 45.2478 25.5625C43.8956 25.8389 42.8389 26.8956 42.5625 28.2478C42.4374 28.86 41.5626 28.86 41.4375 28.2478C41.1611 26.8956 40.1044 25.8389 38.7522 25.5625C38.1399 25.4374 38.1399 24.5626 38.7522 24.4374C40.1044 24.1611 41.1611 23.1043 41.4375 21.7521Z",
    fill: "#B3FF10"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 42C13.0589 42 5 38.4183 5 34C5 29.5817 13.0589 26 23 26M22 21C18.6863 21 16 18.3137 16 15V11C16 7.68629 18.6863 5 22 5C25.3137 5 28 7.68629 28 11V15C28 18.3137 25.3137 21 22 21Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserHubIcon);
export default __webpack_public_path__ + "static/media/user-hub-icon.4a2fec4f15ea53fc7448c4dc3428fe36.svg";
export { ForwardRef as ReactComponent };